'use strict';
import EditFormTabService from './edit-form-service';

export default angular.module('mx.sb.EditForm', []).service('mx.SolutionBuilderAgent.EditFormTabService', EditFormTabService).name;
